var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn module-color-background",attrs:{"href":"#!","model":"action","model-id":_vm.action.id,"loading":'.action'+_vm.action.id},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.actionButtonTitle)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }